import { render } from "./Collection_Management.vue?vue&type=template&id=6e061850"
import script from "./Collection_Management.vue?vue&type=script&lang=js"
export * from "./Collection_Management.vue?vue&type=script&lang=js"

import "./Collection_Management.vue?vue&type=style&index=0&id=6e061850&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__